/** `/pedidos` — lista dos meus pedidos. */
import { useApiQueries } from '@farmacia/api-client/query';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { Pedidos } from '../telas/Pedidos.jsx';

export const Route = createFileRoute('/pedidos/')({ component: TelaDePedidos });

function TelaDePedidos(): ReactNode {
  const queries = useApiQueries();
  const navegar = useNavigate();
  const consulta = useQuery(queries.orders.list());

  return (
    <Pedidos
      pedidos={consulta.data}
      carregando={consulta.isPending}
      erro={consulta.error}
      aoTentarDeNovo={() => void consulta.refetch()}
      aoVerLoja={() => void navegar({ to: '/' })}
    />
  );
}
